export default "__VITE_ASSET__Dff3xACF__"